import "./styles/loginModal.css";
import DirectLogin from "./DirectLogin";

interface ModalProps {
  isOpen: boolean;
  onLoginSuccess?: (token: string) => void;
}

const LoginModal = ({ isOpen, onLoginSuccess }: ModalProps) => {
  if (!isOpen) return null;

  const dismiss = () => {
    const overlay = document.querySelector('.modal-overlay') as HTMLElement;
    if (overlay) overlay.style.display = 'none';
  };

  const socialLinks = [
    { label: "🐦 X / Twitter", url: "https://x.com/PentagonGamesXP" },
    { label: "💬 Discord", url: "https://discord.gg/pentagongamesxp" },
    { label: "✈️ Telegram", url: "https://t.me/pentagongamesxp" },
    { label: "🌐 Pentagon Games", url: "https://pentagon.games" },
  ];

  const gameLinks = [
    { label: "🔫 Gunnies", url: "https://gunnies.io" },
    { label: "⚔️ EtherFantasy", url: "https://etherfantasy.com" },
    { label: "💎 Gemry AI", url: "https://gemry.ai" },
    { label: "🦸 BCSH", url: "https://bcsh.xyz" },
  ];

  const ipLinks = [
    { label: "💱 PentaSwap", url: "https://pentaswap.io" },
    { label: "🖼️ PFP Vault", url: "https://pfpvault.com" },
    { label: "⛏️ NFT Mining", url: "https://nftmining.com" },
    { label: "⭐ Get VIP", url: "https://vip.pentagon.games" },
  ];

  const linkStyle = {
    display: "block",
    padding: "8px 10px",
    borderRadius: "6px",
    background: "rgba(255,255,255,0.1)",
    color: "white",
    textDecoration: "none",
    fontSize: "12px",
    fontWeight: "500" as const,
    textAlign: "center" as const,
    transition: "background 0.2s",
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{
        position: "relative",
        background: "linear-gradient(to bottom, rgb(96, 64, 239), rgb(128, 86, 242))",
        color: "white",
        fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
        maxWidth: "420px",
      }}>
        {/* Close button */}
        <button
          onClick={dismiss}
          style={{
            position: "absolute",
            top: "10px",
            right: "14px",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "22px",
            cursor: "pointer",
            opacity: 0.7,
            padding: "4px 8px",
          }}
          aria-label="Close"
        >✕</button>

        {/* Header */}
        <div style={{ textAlign: "center", padding: "20px 20px 0" }}>
          <h2 style={{ fontFamily: "math", fontSize: "21px", color: "white", marginBottom: "4px" }}>PEN VIP Faucet</h2>
          <p style={{ color: "white", fontSize: "13px", opacity: 0.85, marginTop: "4px" }}>
            Hold PEN on Pentagon Chain. Earn PC gas daily.
          </p>
        </div>

        {/* Direct Login Form */}
        <div style={{ padding: "16px 20px" }}>
          <DirectLogin onSuccess={(token) => {
            if (onLoginSuccess) onLoginSuccess(token);
            dismiss();
          }} />
        </div>

        <hr style={{ width: "80%", margin: "0 auto", opacity: "0.15" }} />

        {/* Ecosystem links - sectioned */}
        <div style={{ padding: "12px 12px 8px" }}>
          <p style={{ fontSize: "11px", opacity: 0.5, marginBottom: "6px", marginTop: 0, textTransform: "uppercase", letterSpacing: "1px" }}>
            Community
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px", marginBottom: "12px" }}>
            {socialLinks.map((link) => (
              <a key={link.label} href={link.url} target="_blank" rel="noreferrer" onClick={dismiss}
                style={linkStyle}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.2)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
              >{link.label}</a>
            ))}
          </div>

          <p style={{ fontSize: "11px", opacity: 0.5, marginBottom: "6px", marginTop: 0, textTransform: "uppercase", letterSpacing: "1px" }}>
            Games & NFTs
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px", marginBottom: "12px" }}>
            {gameLinks.map((link) => (
              <a key={link.label} href={link.url} target="_blank" rel="noreferrer" onClick={dismiss}
                style={linkStyle}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.2)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
              >{link.label}</a>
            ))}
          </div>

          <p style={{ fontSize: "11px", opacity: 0.5, marginBottom: "6px", marginTop: 0, textTransform: "uppercase", letterSpacing: "1px" }}>
            DeFi & IP
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "6px" }}>
            {ipLinks.map((link) => (
              <a key={link.label} href={link.url} target="_blank" rel="noreferrer" onClick={dismiss}
                style={linkStyle}
                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.2)")}
                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(255,255,255,0.1)")}
              >{link.label}</a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
